// Services page copy, word for word from the DIGU Site Reference artifact.
import { ROUTES } from './routes';

export const SERVICES = {
  hero: {
    title: 'Start with one week',
    lede: 'Everything we sell is one fixed fee against a fixed list of deliverables. Almost everyone starts in the same place, and plenty of customers stop after it.',
  },

  frontDoor: {
    eyebrow: 'The front door',
    title: 'Claude Code Security and Adoption Assessment',
    strong: 'One week. Fixed fee, credited in full against anything you sign within thirty days.',
    paragraphs: [
      'We look at your real usage and configuration, score you against thirty two controls, and hand you a ninety day plan where every line has a price next to it. No changes are made to your environment during the week.',
      'You finish the week knowing three things you probably cannot answer today: how many of the seats you pay for are actually used, what an agent could reach if someone tricked it, and whether your logs could tell you afterwards.',
    ],
    actions: [
      { label: 'Book an assessment', to: ROUTES.assessment },
      { label: 'Not ready? Score yourself first', to: ROUTES.score, variant: 'ghost' },
    ],
  },

  ladder: {
    eyebrow: 'The ladder',
    title: 'What usually comes next',
    intro: 'Four engagements. You can take one, several, or none.',
    columns: ['Service', 'Outcome', 'Time'],
    rows: [
      [
        { strong: 'Security Hardening' },
        'The controls in place, and the evidence pack in your hands',
        { time: '3 to 4 weeks' },
      ],
      [
        { strong: 'Claude Code Rollout' },
        'Claude live across your engineering org, with the numbers to prove it',
        { time: '3 weeks' },
      ],
      [
        { strong: 'Cloud Automation with Envaldi' },
        'Create, copy and tear down environments through Claude, safely',
        { time: '3 to 4 weeks' },
      ],
      [
        { strong: 'Claude Run' },
        'Everything kept current as the tools change, with a monthly report',
        { time: 'Monthly' },
      ],
    ],
    closing:
      'Hardening and Rollout overlap, because both configure settings, hooks and telemetry. Bought together they are one engagement at one fee, not two, so you pay for that work once.',
  },

  pricing: {
    eyebrow: 'Pricing',
    title: 'We will send you the numbers before you speak to anyone',
    text: 'Every engagement is a fixed fee against a fixed list of deliverables. We are happy to tell you what they cost. Leave an email and the full fee schedule arrives in one message, with no call in between and nobody chasing you afterwards.',
    actions: [{ label: 'Send me the price list', to: ROUTES.contact }],
    note: {
      lead: 'Why it works this way.',
      text: ' Prices are not on the page, but the request is one click and the answer is immediate and unconditional. That is a different thing from "contact us for pricing", which asks a buyer to book a call to find out whether they can afford you.',
    },
  },

  boundaries: {
    eyebrow: 'Boundaries',
    title: 'What we do not do',
    // The approved paragraph, word for word, split at its sentences: one card per limit,
    // then the closing line.
    items: [
      "We do not certify compliance, that is an accredited auditor's job.",
      'We do not run a security operations center or take 24 hour response duty.',
      'We do not perform penetration testing.',
      'We do not build your SIEM or replace your identity platform.',
    ],
    closing: 'When you need those, we will say so and point you to someone who does them properly.',
  },
};
